import * as React from 'react';
// import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SnackBarComponent = ({ message, severity, onClose }) => {
  return (
    <Snackbar
      open={true} // Snackbar will always open when rendered
      autoHideDuration={6000} // Automatically hide after 6 seconds
      onClose={onClose} // Pass the onClose handler
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBarComponent;
